import usePost from "./usePost";
import { useStateValue } from "../context-store/AppStateProvider";

const useCreateCourse = () => {
  const [{ userId }] = useStateValue();
  const [{ userSisId }] = useStateValue();

  const endpointPath = `courses/user/${userId}/${userSisId}${
    process.env.NODE_ENV === "development" ? "_post_dump" : ""
  }`;

  return usePost(endpointPath);
};

export default useCreateCourse;
